<template>
    <div class="banner">
        <el-carousel trigger="click" height="480px">
	      <el-carousel-item v-for="(item, index) in sliderData" :key="index">
			<router-link :to="item.Url" :href="item.Url" @click.native="OpenLink(item.Url)"><img :src="item.FileUrl"/></router-link>
	      </el-carousel-item>
	    </el-carousel>
    </div>
</template>
<script>
export default {
    name:'slider',
    props:{
        sliderData:{
            type:Array,
            default:()=>[]
        }
    }
}
</script>
<style lang="less" scoped>
.banner{
	width: 100%;
	height: 480px;
    position: relative;
    z-index: 1;
    margin-top: -20px;

	/deep/.el-carousel__indicators--horizontal {
		bottom: 18px;
		.el-carousel__indicator--horizontal button {
			width: 8px;
			height: 8px;
			background: #CCCCCC;
			border-radius: 50%;
			opacity: 1;
		}
		.el-carousel__indicator--horizontal.is-active button {
			width: 40px;
			height: 8px;
			background: #0376BE;
			opacity: 1;
			border-radius: 7px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/slider.vue